import SideBar from "./components/SideBar"
import { Box } from "@mui/material"
import { Outlet } from "react-router-dom"
import Notification from "./components/Notification"

const AppLayout = () => {
    return (
        <div style={{ display: 'flex' }}>
            <Box>
                <SideBar />
            </Box>
            <Box component="main" sx={{ flexGrow: 2 }}>
                <Notification />
                {<Outlet />}
            </Box>
        </div>
    )
}

export default AppLayout;